import { createAction } from 'redux-actions';

import { generateApiActions } from './action-helpers';

const types = {
  FETCH_MEETING_NOTES: 'FETCH_MEETING_NOTES',
  CREATE_MEETING_NOTE: 'CREATE_MEETING_NOTE',
  UPDATE_MEETING_NOTE: 'UPDATE_MEETING_NOTE',
  DELETE_MEETING_NOTE: 'DELETE_MEETING_NOTE',
  SET_MEETING_NOTE_OPEN_MONTH: 'SET_MEETING_NOTE_OPEN_MONTH',
  SET_OPEN_MEETING_NOTE: 'SET_OPEN_MEETING_NOTE',
  SET_PAGE: 'SET_PAGE',
  RESET_MEETING_NOTES_DATA: 'RESET_MEETING_NOTES_DATA',
};

export const {
  createMeetingNoteRequest,
  createMeetingNoteSuccess,
  createMeetingNoteFailure,
} = generateApiActions(types.CREATE_MEETING_NOTE);

export const {
  updateMeetingNoteRequest,
  updateMeetingNoteSuccess,
  updateMeetingNoteFailure,
} = generateApiActions(types.UPDATE_MEETING_NOTE);

export const {
  deleteMeetingNoteRequest,
  deleteMeetingNoteSuccess,
  deleteMeetingNoteFailure,
} = generateApiActions(types.DELETE_MEETING_NOTE);

export const {
  fetchMeetingNotesRequest,
  fetchMeetingNotesSuccess,
  fetchMeetingNotesFailure,
} = generateApiActions(types.FETCH_MEETING_NOTES);

export const setMeetingNoteOpenMonth = createAction(types.SET_MEETING_NOTE_OPEN_MONTH);
export const setOpenMeetingNote = createAction(types.SET_OPEN_MEETING_NOTE);
export const setPage = createAction(types.SET_PAGE);

export const resetMeetingNotesData = createAction(types.RESET_MEETING_NOTES_DATA);



// WEBPACK FOOTER //
// ./src/redux/actions/meeting-notes.js